import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart: [],
};

export const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    addToCart(state, action) {
      const initialCart = state.cart;

      initialCart.push(action.payload);

      state.cart = initialCart;
    },
    removeFromCart(state, action) {
      const initialCart = state.cart;

      initialCart.splice(action.payload, 1);

      state.cart = initialCart;
    },
    clearCart(state, action) {
      state.cart = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const { addToCart, removeFromCart, clearCart } = pageSlice.actions;

export default pageSlice.reducer;
